module.exports = __webpack_public_path__ + "static/img/invitingFriendsBg.f8d78fb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/invitingFriendsBg.webp
// module id = 8SNf
// module chunks = 0